export default __webpack_public_path__ + "static/media/477.e4b11919.jpg";